import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { formatInputDateValue, formatDateForAPI } from "utils/helper";
import { useDateValidation } from "utils/customHooks";
import { LANG } from "constants/constants";
import propTypes from "prop-types";

const MultiDateSelector = ({
  min,
  onChange,
  error,
  defaultValue,
  lang = LANG.FR,
}) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [inputValues, setInputValues] = useState([]);

  const { validateAndFormatDate } = useDateValidation();

  const handleDateChange = (newDate, index) => {
    const changedData = selectedDates.map((date, i) =>
      i === index ? newDate : date
    );
    setSelectedDates(changedData);
    onChange(changedData);
  };

  const handleRemoveDate = (index) => {
    const changedData = selectedDates.filter((date, i) => i !== index);
    const changedInputValues = inputValues.filter((value, i) => i !== index);
    setSelectedDates(changedData);
    setInputValues(changedInputValues);
    onChange(changedData);
  };

  const handleInputChange = (rawValue, index) => {
    if (rawValue.length > 10) return;

    const formattedValue = formatInputDateValue(rawValue);
    const newInputValues = [...inputValues];
    newInputValues[index] = formattedValue;
    setInputValues(newInputValues);

    if (formattedValue.length === 10) {
      validateAndFormatDate(
        formattedValue,
        lang,
        (parsedDate) => {
          const apiFormattedDate = formatDateForAPI(parsedDate);
          handleDateChange(apiFormattedDate, index);
        },
        (dayMonth) => {
          const newInputValues = [...inputValues];
          newInputValues[index] = dayMonth;
          setInputValues(newInputValues);
        }
      );
    }
  };

  useEffect(() => {
    setSelectedDates([]);
    setInputValues([]);
  }, [min]);

  useEffect(() => {
    setSelectedDates(defaultValue || []);
    setInputValues(defaultValue?.map(() => "") || []);
  }, [defaultValue]);

  return (
    <div>
      {selectedDates?.map((value, index) => (
        <div key={index}>
          <input
            type="text"
            placeholder={lang === LANG.EN ? "MM/DD/YYYY" : "JJ/MM/AAAA"}
            value={inputValues[index] || ""}
            onChange={(event) => handleInputChange(event.target.value, index)}
            style={{ borderColor: error || null }}
          />
          <button onClick={() => handleRemoveDate(index)}>
            <FormattedMessage id={"delete"} defaultMessage={"Supprimer"} />
          </button>
        </div>
      ))}
      <div>
        <input
          style={{ borderColor: error || null }}
          type="text"
          placeholder={lang === LANG.EN ? "MM/DD/YYYY" : "JJ/MM/AAAA"}
          value=""
          onChange={(event) => {
            if (event.target.value) {
              handleInputChange(event.target.value, selectedDates.length);
            }
          }}
        />
      </div>
    </div>
  );
};

export default MultiDateSelector;

MultiDateSelector.propTypes = {
  min: propTypes.number,
  onChange: propTypes.func,
  error: propTypes.string,
  defaultValue: propTypes.array,
  lang: propTypes.string,
};

MultiDateSelector.defaultProps = {
  min: null,
  onChange: null,
  error: null,
  defaultValue: [],
  lang: LANG.EN,
};
